<div class="confirmation-dialog" data-testid="submit-confirm-dialog" role="dialog" aria-modal="true" aria-labelledby="submit-confirm-title">
  <!-- Header bar -->
  <div class="dialog-title-bar">
    <h3 class="dialog-title" id="submit-confirm-title">New Translation Quote Request</h3>
    <button class="close-btn" (click)="cancel()" aria-label="Close dialog" data-testid="submit-confirm-close-btn">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6.36436 19.0588L4.96436 17.6588L10.5644 12.0588L4.96436 6.45884L6.36436 5.05884L11.9644 10.6588L17.5644 5.05884L18.9644 6.45884L13.3644 12.0588L18.9644 17.6588L17.5644 19.0588L11.9644 13.4588L6.36436 19.0588Z"
        fill="white"
      />
    </svg>
  </button>
  </div>

  <mat-dialog-content class="dialog-body">
    <p class="dialog-message">
      Once submitted, you will not be able to change the translation
      requirements for this job.
    </p>
    <p class="dialog-question">
      Are you sure you want to submit this intake form?
    </p>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button
      type="button"
      class="btn btn-outline"
      (click)="cancel()"
      data-testid="submit-confirm-no-btn"
      cdkFocusInitial>
      No
    </button>
    <button
      type="button"
      class="btn btn-primary"
      data-testid="submit-confirm-yes-btn"
      (click)="confirm()">
      Yes
    </button>
  </mat-dialog-actions>
</div>
